import { useSelector } from 'react-redux';
import DeliveryLocation from '../../DeliveryLocation';
import { useState } from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet';

const DeliveryOption = (props) => {
	const { errors = null, touched = null, values = {} } = props;
	const user = useSelector((store) => store?.user);
	const [isShowBottomSheet, setIsShowBottomSheet] = useState(false);

	const handleCloseBottomSheet = () => {
		setIsShowBottomSheet(false);
	};

	const handleClick = async () => {
		setIsShowBottomSheet(true);
	};

	return (
		<>
			<div className={`mx-4 mt-4 flex justify-between items-center ${values?.orderType != 'delivery' ? 'hidden' : ''}`}>
				<div>
					<div className='text-xs text-gray-900 font-semibold'>Lokasi Pengiriman</div>
					<div className='text-sm text-gray-900 font-semibold pt-2 max-w-64 overflow-ellipsis line-clamp-2'>{user?.address}</div>
				</div>
				<button
					id='summary_change_location'
					className={`${
						errors?.destinations?.address && touched?.destinations?.address ? 'border-red-500 text-red-500' : 'border-[var(--rose-violet)] text-[var(--rose-violet)]'
					} bg-white border-solid border-1 py-2 px-4 text-xs font-semibold rounded-md min-w-fit`}
					onClick={handleClick}>
					Ubah
				</button>
			</div>
			<BottomSheet
				key={'select-location-summary'}
				open={isShowBottomSheet}
				onDismiss={handleCloseBottomSheet}
				snapPoints={({ minHeight, maxHeight }) => {
					return [minHeight, maxHeight * 0.75];
				}}>
				<DeliveryLocation onClose={handleCloseBottomSheet} />
			</BottomSheet>{' '}
		</>
	);
};

export default DeliveryOption;
